export type MarketInsightsVariant = "preMarket" | "postMarket" | "weekend";

export interface MarketInsightsHeadingCopy {
  preMarketTitle?: string;
  preMarketSubtext?: string;
  postMarketTitle?: string;
  postMarketSubtext?: string;
  weekendTitle?: string;
  weekendSubtext?: string;
}

export const getMarketInsightsVariant = (
  now: Date = new Date(),
): MarketInsightsVariant => {
  const hours = now.getUTCHours();
  const minutes = now.getUTCMinutes();
  const day = now.getUTCDay(); // 0 = Sunday, 6 = Saturday

  const currentTime = hours * 60 + minutes;

  // IST offsets converted to UTC:
  // 12:00 AM IST → 6:30 PM previous day UTC (18:30 → 1110 mins)
  // 3:40 PM IST → 10:10 AM UTC (610 mins)

  // Define ranges in UTC minutes
  const preMarketStart = 18 * 60 + 30; // 18:30 UTC (previous day)
  const preMarketEnd = 10 * 60 + 10; // 10:10 UTC

  // Weekend check (Saturday + Sunday full override)
  if (day === 0 || day === 6) {
    return "weekend";
  }

  // Handle overnight span (pre-market crosses midnight UTC)
  if (
    (currentTime >= preMarketStart && currentTime <= 1440) || // 18:30 → 24:00
    (currentTime >= 0 && currentTime <= preMarketEnd) // 00:00 → 10:10
  ) {
    return "preMarket";
  }

  // Everything else = post-market
  return "postMarket";
};

export const getMarketInsightsHeadingCopy = (
  content: MarketInsightsHeadingCopy,
  variant: MarketInsightsVariant,
): { title: string; subtext: string } => {
  if (variant === "preMarket") {
    return {
      title:
        content.preMarketTitle ??
        content.postMarketTitle ??
        content.weekendTitle ??
        "",
      subtext:
        content.preMarketSubtext ??
        content.postMarketSubtext ??
        content.weekendSubtext ??
        "",
    };
  }

  if (variant === "postMarket") {
    return {
      title:
        content.postMarketTitle ??
        content.preMarketTitle ??
        content.weekendTitle ??
        "",
      subtext:
        content.postMarketSubtext ??
        content.preMarketSubtext ??
        content.weekendSubtext ??
        "",
    };
  }

  return {
    title:
      content.weekendTitle ??
      content.preMarketTitle ??
      content.postMarketTitle ??
      "",
    subtext:
      content.weekendSubtext ??
      content.preMarketSubtext ??
      content.postMarketSubtext ??
      "",
  };
};

export const getMarketInsightsHeadingCopyByTime = (
  content: MarketInsightsHeadingCopy,
): { title: string; subtext: string } => {
  const variant = getMarketInsightsVariant();
  return getMarketInsightsHeadingCopy(content, variant);
};
